// extracted by mini-css-extract-plugin
export default {"followNftButton":"t5H2PRIilCnqnXcq4RZG"};